import type { ObjectId } from '@freightview/object-id'

import type { DocProcessorResult } from '../models/document-center.ts'
import type { vOutput } from '../validation/index.ts'
import {
  vBoolean,
  vFallback,
  vObject,
  vOptional,
  vPicklist,
  vString,
  vStringToNumber,
} from '../validation/schema/core.ts'
import { aiModels } from './ai.ts'

export const parseAccountDocumentSchema = vObject({
  file: vString(),
})
export type ParseAccountDocumentRequest = vOutput<
  typeof parseAccountDocumentSchema
>

const documentLoadMatchMethods = [
  'trackingNumber',
  'bolNumber',
  'shipperNumber',
  'poNumber',
] as const
export type DocumentLoadMatchMethod = (typeof documentLoadMatchMethods)[number]
export interface DocumentLoadMatchResult {
  processedData: DocProcessorResult
  loads: DocumentLoadMatch[]
}
export interface DocumentLoadMatch {
  loadId: string
  method: DocumentLoadMatchMethod
  value: string
}

export const docEntryReviewSchema = vObject({
  loadId: vString(),
  action: vPicklist(['approve', 'reject']),
})
export type DocEntryReviewRequest = vOutput<typeof docEntryReviewSchema>

export const updateDocCenterPromptsSchema = vObject({
  identifierPrompt: vOptional(vString()),
  refNumPrompt: vOptional(vString()),
  listBillRefNumPrompt: vOptional(vString()),
  singleInvoicePrompt: vOptional(vString()),
  listInvoicePrompt: vOptional(vString()),
  aiModel: vOptional(vPicklist(aiModels)),
})
export type UpdateDocCenterPromptsRequest = vOutput<
  typeof updateDocCenterPromptsSchema
>

export const retryDocEntrySchema = vObject({
  persist: vBoolean(),
})

export type RetryDocEntryRequest = vOutput<typeof retryDocEntrySchema>

export const adminAccountDocumentFilterSchema = vObject({
  limit: vFallback(vStringToNumber(), 50),
  continuationToken: vOptional(vString()),
})
export type AdminAccountDocumentFilter = vOutput<
  typeof adminAccountDocumentFilterSchema
>

export interface DocCenterReportResult {
  accountId: ObjectId
  totalEntries: number
  entriesWithLoads: number
  entriesWithoutLoads: number
  totalLoads: number
  loadsApproved: number
  loadsRejected: number
  pagesProcessed: number
  totalTokens: number
}
